import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/consignee/manage.php`,
};

const ConsigneeService = () => {
  const list = (cuscode) => api.get(`${API_URL.API_MANAGE}?cuscode=${cuscode}`);
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (id) => api.delete(`${API_URL.API_MANAGE}?id=${id}`);

  return { list, create, update, deleted };
};

export default ConsigneeService;
